import { render, staticRenderFns } from "./SearchMaterials.vue?vue&type=template&id=e9eb3ffe&scoped=true"
import script from "./SearchMaterials.vue?vue&type=script&lang=ts"
export * from "./SearchMaterials.vue?vue&type=script&lang=ts"
import style0 from "./SearchMaterials.vue?vue&type=style&index=0&id=e9eb3ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9eb3ffe",
  null
  
)

export default component.exports